import { type CodexReasoningEffort } from "@t3tools/contracts";

export const REASONING_EFFORT_LABEL_BY_VALUE = {
  max: "Max",
  xhigh: "Extra High",
  high: "High",
  medium: "Medium",
  low: "Low",
} as const satisfies Record<CodexReasoningEffort, string>;

export function getReasoningEffortLabel(effort: CodexReasoningEffort): string {
  return REASONING_EFFORT_LABEL_BY_VALUE[effort];
}
